export enum ActiveSplitExperiment {
    ACTIVATE_ZHL_DASHBOARD_USER = 'ACTIVATE_ZHL_DASHBOARD_USER',
    HOME_LOANS_DASHBOARD_AUTH_MIGRATION = 'HOME_LOANS_DASHBOARD_AUTH_MIGRATION',
    HOME_LOANS_DASHBOARD_ENABLE_DIGITAL_PREAPPROVAL_EXPERIENCE = 'HOME_LOANS_DASHBOARD_ENABLE_DIGITAL_PREAPPROVAL_EXPERIENCE',
    HOME_LOANS_DASHBOARD_SHORT_AUTH = 'HOME_LOANS_DASHBOARD_SHORT_AUTH',
}

export const UNIVERSAL_SPLIT_EXPERIMENTS = [
    ActiveSplitExperiment.ACTIVATE_ZHL_DASHBOARD_USER,
    ActiveSplitExperiment.HOME_LOANS_DASHBOARD_AUTH_MIGRATION,
    ActiveSplitExperiment.HOME_LOANS_DASHBOARD_SHORT_AUTH,
];
export enum FeatureFlagStatus {
    OFF = 'off',
    ON = 'on',
}
